export default __webpack_public_path__ + "static/media/725.9b5adbd8.png";